<template>
    <div class="band" :class="{'disabled' : disabled}">
        <img src="@/assets/img/band-black.png" alt="band">

        <div class="info">
            <h3>{{ name }}</h3>
            <p>user: {{ getUserType(user) }}</p>
        </div>

        <!-- button for no user (display only) -->
        <button 
            class="button--ok" 
            @click="$emit('login')"
            v-if="!loggedIn"
            disabled
        >
            {{ $t('login') }}
        </button>

        <button 
            class="button--ok" 
            @click="$emit('login')"
            v-if="loggedIn && getUserType(user) === $t('default')"
        >
            {{ $t('login') }}
        </button>
        <button 
            class="button--edit" 
            @click="$emit('edit')"
            v-if="loggedIn && getUserType(user) !== $t('default')"
        >
            {{ $t('edit') }}
        </button>
        <button 
            class="button--cancel" 
            @click="$emit('logout')"
            :disabled="!loggedIn"
        >
            {{ $t('logout') }}
        </button>

        <!-- <div class="options">
            <span class="icon" @click="showOptions = !showOptions"><span></span><span></span><span></span></span>
            <div class="option" v-if="showOptions">
                <button @click="edit()">Edit</button>
            </div>
        </div> -->
    </div>
</template>

<script>
export default {
	props: ['name', 'user', 'disabled', 'loggedIn'],

	data () {
		return {
			showOptions: false
		}
	},

	methods: {
		getUserType (user) {
			if (!user) return this.$t('no_user')

			if (user.is_guest) {
				if (user.created_at !== user.updated_at) return this.$t('guest')
				else return this.$t('default')
			} else {
				if (user.facebook_id) return `FB ${this.$t('login')}`
				else return this.$t('registered')
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.band {
    display: flex;
    background-color: #fff;
    box-shadow: 0 3px 6px #00000029;
    padding: 10px;
    align-items: center;
    height: 5rem;
    position: relative;

    &.disabled {
        filter: grayscale(1);
        opacity: 0.5;
    }

    img {
        width: 4rem;
        flex-shrink: 0;
    }

    .info {
        flex: 1 1 auto;
        padding: 0 1rem;
        width: 170px;

        h3 {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }

    button {
        align-self: center;
        margin-right: 10px;
        width: 70px;

        &:last-child {
            margin-right: 0px;
        }

        &:disabled {
            opacity: 0.4;
        }
    }

    .options {
        position: absolute;
        top: 0;
        right: 5px;

        .icon {
            span {
                display: inline-block;
                width: 5px;
                height: 5px;
                background-color: #ddd;
                margin-left: 3px;
                border-radius: 50%;
                cursor: pointer;
            }
        }

        .option {
            position: absolute;
            top: 20px;
            right: -5px;
            margin-top: .5rem;
            box-shadow: 0 3px 6px #aaa;
            background-color: #fff;
            z-index: 999;

            button {
                width: 100px;
            }
        }
    }

    @include mobile {
        font-size: 1.5rem;
        padding: 1rem;

        .info {
            display: flex;

            h3 {
                margin-right: 1em;
            }
        }

        button, p {
            font-size: 1em;
        }

        button {
            width: 5em;
        }
    }
}
</style>
